<template>
  <div>
    <head>
      <title>Payment Successful!</title>
    </head>

    <body>
      <div class="wrapper">
        <img class="logo" src="../../../assets/images/fonepay_logo.jpg" />

        <div class="content">
          <h2 class="normal">Payment</h2>
          <h2 class="type">Successful :)</h2>
          <h2 class="normal">Transaction Id</h2>
          <h2 class="trans-id">{{ this.refId }}</h2>
          <h2 class="normal">Order Id</h2>
          <h2 class="trans-id">{{ this.orderID }}</h2>

          <a href="https://khaanpin.com.np">Continue Shopping</a>
        </div>
        <!-- eo content -->
      </div>
      <!-- eo wrapper -->
    </body>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { CartData, FonePayInfo } from "../../../services/storage.service";

export default {
  name: "SuccessPage",
  data() {
    return {
      refId: FonePayInfo.getTransactionId() || 0,
      orderID: FonePayInfo.getOrderId() || 0,
    };
  },
  // created() {
  //   this.refId = this.$route.query.ref_id;
  //   this.orderID = this.$route.query.order_id;
  // },
  methods: {
    ...mapActions(["clearCart"]),

    clearTheCart() {
      this.clearCart();
      CartData.removeOrderId();
      CartData.removeDeliveryCharge();
      CartData.removeCartTotal();
    },
  },
  mounted() {
    this.clearTheCart();
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

body {
  background: #fefefe;
}
.wrapper {
  text-align: center;
  font-family: sans-serif;
  margin-top: 100px;
  margin-bottom: 6%;
}
h2 {
  font-size: 14px;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 20px;
  color: #333;
}
.logo {
  width: 150px;
  margin-top: 40px;
}
.content {
  margin-top: 10px;
}
.type {
  font-size: 24px;
  letter-spacing: 12px;
  background: #3dd23d;
  padding: 10px 20px;
  color: #fff;
  display: inline-block;
}
.trans-id {
  color: red;
}
a {
  display: inline-block;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 5px;
  margin-top: 40px;
  color: #333;
}
</style>
